module.exports = __webpack_public_path__ + "static/media/add-to-cart.0cd24c2d.svg";